import React from 'react';
import clsx from 'clsx';

import './index.scss';

import CheckIcon from 'components/atoms/Icon/CheckIcon';
import StepIcon from 'components/atoms/Icon/StepIcon';

const PcProgress = ({ step, status, title, hasBar, selects = [] }) => {
  const Icon = {
    done: <CheckIcon color="0" />,
    doing: <StepIcon step={step} doing />,
    todo: <StepIcon step={step} />,
  };

  return (  
    <div className="PcProgress">
      <div className="wrapper">
        {/* タイトル、選択済み項目 */}
        <div className={clsx('title-area', { doing: status === 'doing' })}>
          <div className="title">{title}</div>
          <ul className="selects">
            {selects.map(select => {
              if(!select) return null;
              return (
                <li key={select} className="select">
                  {select}
                </li>
              );
            })}
          </ul>
        </div>

        {/* アイコン・バー */}
        <div className="icon">
          {hasBar && <div className={clsx('bar', { doing: status === 'doing' })} />}
          {Icon[status]}
        </div>
      </div>
    </div>
  );
};


export default PcProgress;